import { FC } from 'react';
import { Navigate, useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { SupportedLanguages } from '@/environment';

export const LanguageRoute: FC = () => {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const { i18n } = useTranslation();

  if (params.lng && SupportedLanguages.includes(params.lng)) {
    i18n.changeLanguage(params.lng);
  }

  return <Navigate to={`/${params['*'] || ''}?${searchParams.toString()}`} />;
};
